export default function quoteDuplicate(param) {
  param.type = "duplicate"
  this.quoteNewVersion(param);
}